import * as z from "zod";

const schema = z.object({
	id: z.string().default("")
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountantRegisterResModel = {schema, model};
export type ITaxAccountantRegisterResModel = z.infer<typeof TaxAccountantRegisterResModel.model>;
export const DEFAULT_TAX_ACCOUNTANT_REGISTER_RES: ITaxAccountantRegisterResModel = {
	id: ""
};
